<template>
  <div class="i-tier-benefit">
    <img
      :src="props.iconUrl"
      loading="lazy"
      class="icon"
    />

    <div class="right">
      <div class="top">
        <div class="title">
          {{ props.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// PROPS
const props = defineProps({
  iconUrl: String,
  title: String
})

// EMITS
defineEmits(["clickedOnTooltip"])
</script>

<style scoped lang="scss">
.i-tier-benefit {
  @include flex($direction: row, $justify: start, $align: flex-start);

  margin-bottom: 16px;
  text-align: left;

  .icon {
    width: 24px;
    height: 24px;
  }

  .right {
    margin-left: 4px;
  }

  .top {
    @include flex($direction: row, $justify: start, $align: flex-start);

    margin-bottom: 4px;
  }

  .title {
    font-weight: 600;

    @include text-sm;

    @media screen and (min-width: $breakpoint-md) {
      @include text-md;
    }

    @media screen and (min-width: $breakpoint-xl) {
      @include text-sm;
    }
  }

  .html {
    @include text-sm;
  }

  .tooltip {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: center;
    width: 20px;

    img {
      height: 12px;
      width: 12px;
    }
  }
}
</style>
